var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 91,
    viewBox: "0 0 150 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.452 24.0085L147.543 16.757C147.299 15.81 146.793 14.9513 146.081 14.2799C145.37 13.6086 144.484 13.152 143.525 12.9628L79.3604 0.412812C77.2493 -0.0103525 75.0598 0.208598 73.0742 1.04143L34.0997 19.7429C33.1128 16.8238 31.028 14.4036 28.2871 12.9955C25.5462 11.5873 22.3647 11.3018 19.4169 12.1995L9.20185 15.2977C6.18926 16.2151 3.66437 18.2914 2.1824 21.0701C0.700439 23.8488 0.382746 27.1023 1.29919 30.1151L17.1943 82.3805C18.1117 85.3931 20.188 87.918 22.9667 89.3999C25.7454 90.8819 28.9989 91.1996 32.0118 90.2831L42.2269 87.1849C44.6345 86.4436 46.7448 84.9573 48.2537 82.94C49.7627 80.9227 50.5924 78.4786 50.6235 75.9596L91.8879 73.8492C94.0922 73.713 96.194 72.8707 97.8823 71.447L147.768 29.2396C148.51 28.6129 149.062 27.7903 149.36 26.8654C149.657 25.9405 149.689 24.9507 149.452 24.0085Z",
    fill: "#F2EAE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.621 20.8213L97.478 34.1121",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1934 44.8648C93.9299 44.8648 97.7696 41.0251 97.7696 36.2886C97.7696 31.5521 93.9299 27.7124 89.1934 27.7124C84.4569 27.7124 80.6172 31.5521 80.6172 36.2886C80.6172 41.0251 84.4569 44.8648 89.1934 44.8648Z",
    fill: "#F2EAE2",
    stroke: "#082C4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.de5cfdf00890717f4356cddc7d78d423.svg";
export { ForwardRef as ReactComponent };